module.exports = __webpack_public_path__ + "static/014.thumb-b93bfc43350e7117fa44857ede3187d2.jpg";